import React, { useState } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import schoolApi from "../api/schoolApi";
import { ToastContainer, toast } from 'react-toastify';
import { useLocation  } from 'react-router-dom';


const ResetPassword = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({newPassword:"",confirmPassword:""});
  const [show, setShow] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState();
  let [confirmMatch, setConfirmMatch] = useState(false);
  const location = useLocation ();
  const email = location.pathname.split('/').pop(); // Extract email from the path
  const school_code = location.state?.school_code;
  const [passwordError, setPasswordError] = useState("");

  const handleSubmit = async (e) => {
    try{
    e.preventDefault();
    if (Object.keys(passwordError).length > 0) {
      return toast.error("Invalid password");
    }
    const result = await schoolApi.ResetPassword(email,credentials.newPassword,school_code)
    if(result.success) {
        toast.success(result.message);
        setTimeout(() => {
            navigate('/');
        }, 2000);
    }
    else{
        toast.error(result.message)
        setTimeout(() => {
            navigate('/forget-password');
        }, 2000);
    }
    setPasswordError()
    }catch (error) {
        return toast.error(error.response.data.message)
    }
  };
  const handleChange = (e) => {
    console.log("name == ",e.target.name)
    if(e.target.name === "newPassword"){
      const trimmedValue = e.target.value.replace(/\s/g, ''); 
      console.log("trimmedValue->",trimmedValue);
      
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      const isValidPassword = passwordRegex.test(trimmedValue);
      setCredentials({ ...credentials, [e.target.name]: trimmedValue});
      if (!isValidPassword) {
        setPasswordError("Password must be 8+ characters with uppercase, lowercase, number & special character.")
      } else {
        setPasswordError("");
      }
      }else{
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
      }
  };


  return (
    <Container>
    {/* <span className="box1"></span>
    <span className="box2"></span> */}
    <div className="login-form-section">
      <div className="forget-form-content">
        <div className="p-4">
          <Form className="mt-2" onSubmit={handleSubmit}>
            
              <div className="">
                <h3 className="text-center ">
                  {" "}
                  <img src="comonLogoSchool.png" className="mb-2" height="100px" />
                </h3>
              </div>
            
            <Alert variant="danger" show={show}>
              {errorMessage}
            </Alert>
            <Form.Group
              className="mb-3 mt-2"
              controlId="formBasicusername"
            >
              <Row className="mt-3">
                <Col lg={12}>
                  <Form.Label>Create New Password</Form.Label>
                     <Form.Control
                       type="password"
                       name="newPassword"
                       onChange={handleChange}
                       placeholder="Enter New Password Password"
                       value={credentials.newPassword}
                     />
                      {
                        passwordError ?
                          <span style={{ color: '#DC3545', fontWeight: '600',paddingTop:"5px",fontSize:"6.90px" }}>
                            {/* <i class="fa-regular fa-circle-check pt-1 px-1"></i> */}
                            {passwordError}
                          </span>
                        :''
                      }
                </Col>
              </Row>
                <Row className="mt-3">
                  <Col lg={12}>
                    <Form.Label>Confirm New Password</Form.Label>
                      <Form.Control
                         type="password"
                         name="confirmPassword"
                         onChange={handleChange}
                         placeholder="Confirm New Password Password"
                         value={credentials.confirmPassword}
                      />
                      <b className="mt-3">
                         {credentials.newPassword && credentials.confirmPassword ?
                         (credentials.newPassword === credentials.confirmPassword ?
                           "Passwords Match" : "Passwords do not match") : ""}
                      </b>
                    <div className="mt-2">
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3">
                <Col lg={12}>
                  <Button
                    className="btn btn-lg w-100 submit"
                    variant="primary"
                    type="submit"
                    disabled={!credentials.newPassword || (credentials.newPassword !== credentials.confirmPassword)}
                  >
                    Create
                  </Button>
                </Col>
              </Row>
            </Form.Group>
            <center className="mt-3">
              <strong><Link to="/forget-password" style={{ textDecoration: 'none' }}>Go Back</Link></strong>
            </center>
          </Form>

          <center className="indicrm">
          </center>
        </div>
      </div>
    </div>
    <ToastContainer />
    </Container>
  );
};
export default ResetPassword;